import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const CoffeeCupSmall = t0 => {
  const $ = _c(8);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M11.3333 7.73331V9.99998C11.3333 12.2091 9.54247 14 7.33333 14H6C3.79086 14 2 12.2091 2 9.99998V7.73331C2 7.51238 2.17909 7.33331 2.4 7.33331H10.9333C11.1543 7.33331 11.3333 7.51238 11.3333 7.73331Z" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M8 5.99998C8 5.33331 8.4762 4.66665 9.4286 4.66665C10.4805 4.66665 11.3333 3.81385 11.3333 2.76189V2.33331" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M5.33331 6V5.66667C5.33331 4.5621 6.22875 3.66667 7.33331 3.66667C8.06971 3.66667 8.66665 3.06971 8.66665 2.33333V2" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M10.6667 7.33331H12.3334C13.2538 7.33331 14 8.07951 14 8.99998C14 9.92045 13.2538 10.6666 12.3334 10.6666H11.3334" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props) {
    t5 = <IconWrapper {...props} variant="outline" viewBox="0 0 16 16">{t1}{t2}{t3}{t4}</IconWrapper>;
    $[6] = props;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export { CoffeeCupSmall };